import { Autocomplete, IconButton, TextField, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { AcolitosContext } from "../../../context/AcolitosContext";
import { Delete } from "@mui/icons-material";
export const Acolitos = ({ acolito, tipo_misa, puestos, onEdit, onDelete }) => {
  const { data: acolitos } = useContext(AcolitosContext);

  const [stateLocal, setStateLocal] = useState({
    ...acolito,
  });

  useEffect(() => {
    onEdit(stateLocal);
  }, [stateLocal]);

  useEffect(() => {
    //Comparar el objeto acolito con state local de una manera completa
    if (JSON.stringify(acolito) !== JSON.stringify(stateLocal)) {
      setStateLocal({
        ...acolito,
      });
    }
  }, [acolito]);

  if (
    tipo_misa === "" ||
    tipo_misa === 0 ||
    tipo_misa === undefined ||
    tipo_misa === null ||
    puestos.length === 0
  ) {
    return;
  }

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        marginBottom: 10,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Eliminar acólito */}
      <div
        style={{
          display: "flex",
          // flex: 1,
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Tooltip title="Eliminar">
          <IconButton onClick={() => onDelete(stateLocal.id)}>
            <Delete color={"primary"} />
          </IconButton>
        </Tooltip>
      </div>

      <Autocomplete
        disablePortal
        fullWidth
        // freeSolo
        options={puestos}
        getOptionLabel={(option) => option.nombre || ""}
        // fullWidth
        // sx={{ width: 150 }}
        style={{ display: "flex", flex: 1, marginRight: 10 }}
        renderInput={(params) => <TextField {...params} label="Puesto" />}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={
          puestos.find((puesto) => puesto.id === stateLocal.id_puesto) || null
        }
        onChange={(event, value) => {
          setStateLocal((s) => {
            return {
              ...s,
              id_puesto: value ? value.id : null,
              puesto: value ? value.nombre : "",
            };
          });
        }}
        noOptionsText="Sin resultados"
      />
      <Autocomplete
        disablePortal
        options={acolitos}
        value={
          acolitos.find((acolito) => acolito.id === stateLocal.id_acolito) ||
          null
        }
        getOptionLabel={(option) => option.nombre_completo || ""}
        // fullWidth
        renderInput={(params) => (
          <TextField {...params} label={"Nombre del Acólito"} />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(event, value) => {
          if (value) {
            setStateLocal((s) => {
              return {
                ...s,
                id_acolito: value.id,
                nombre: value.nombre_completo,
              };
            });
          } else {
            setStateLocal((s) => {
              return {
                ...s,
                id_acolito: null,
                nombre: "",
              };
            });
          }
        }}
        noOptionsText="Sin resultados"
        style={{ display: "flex", flex: 2 }}
        sx={{
          ".MuiAutocomplete-tag": {
            backgroundColor: "pink",
          },
        }}
      />
    </div>
  );
};
